const path = require('path')

module.exports = {
  devServer: {
    // proxy: process.env.NODE_ENV === 'production'
    // ? ''
    // : 'https://freshcoffee.indyn.de',
    proxy: 'https://freshcoffee.online',
  },

  outputDir: 'generator',
  assetsDir: '',

  chainWebpack: config => {
    const types = ['vue-modules', 'vue', 'normal-modules', 'normal']
    types.forEach(type => addStyleResource(config.module.rule('scss').oneOf(type)))
  },

  pluginOptions: {
    i18n: {
      locale: 'de',
      fallbackLocale: 'de',
      localeDir: 'locales',
      enableInSFC: false
    }
  }
}

function addStyleResource(rule) {
  rule.use('style-resource')
    .loader('style-resources-loader')
    .options({
      patterns: [
        path.resolve(__dirname, './src/styles/_imports.scss'),
      ],
    })
}